<h1 class="player-name">{{ playerName$ | async }}</h1>
<ng-template let-item #favorites>
  <div (click)="openTimePicker(item.id)">
    <mwo-smart-cover [mode]="'playlist'" [item]="item" [coverTitle]="item.event.name" [coverSrc]="item.event.artwork" [color]="item.event.color"></mwo-smart-cover>
  </div>
</ng-template>

<mwo-smart-grid [list]="favorites$" [itemTpl]="favorites" [hasSettings]="true" >
  <h3 previousPage>{{ 'library.title' | translate }}</h3>
  <h2 header>{{ 'library.mainFamilies.favorites' | translate }}</h2>
</mwo-smart-grid>
